import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="bg-white rounded-md border" style={{
    borderColor: '#e2e8f0'
  }} data-id="element-130">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 text-left cursor-pointer" aria-expanded={isOpen} data-id="element-131">
        <span className="text-base md:text-lg font-bold pr-4" style={{
        color: '#0f172a'
      }} data-id="element-132">
          {question}
        </span>
        <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} style={{
        color: '#64748b'
      }} aria-hidden="true" data-id="element-133" />
      </button>
      {isOpen && <div className="px-5 pb-5" data-id="element-134">
          <p className="text-base leading-relaxed" style={{
        color: '#64748b'
      }} data-id="element-135">
            {answer}
          </p>
        </div>}
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#f8fafc',
    borderColor: '#e2e8f0'
  }} data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-10 text-center" style={{
        color: '#0f172a'
      }} data-id="element-138">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-12" data-id="element-139">
          <FAQItem question="¿Qué recibo exactamente?" answer="Una Guía Completa en PDF con todo el sistema paso a paso. Descarga inmediata en cualquier dispositivo." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-140" />

          <FAQItem question="¿Puedo construir una página en menos de 1 hora?" answer="Sí. Una vez que copias los prompts y sigues la guía visual, la IA hace el trabajo. La primera vez puede tomar un poco más. Desde el segundo proyecto, menos de 1 hora." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-141" />

          <FAQItem question="¿Cuánto cuesta en total?" answer="La guía cuesta $49.999 como pago único. Las herramientas de IA que usamos son gratis. Eso es todo lo que necesitas para empezar." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-142" />

          <FAQItem question="¿Qué pasa si no encuentro clientes?" answer="El Capítulo 5 te da el manual de juego exacto. Con el plan de 30 días, la mayoría de las personas tienen su primer cliente en 2 semanas." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-143" />

          <FAQItem question="¿Qué pasa si no funciona para mí?" answer="Garantía de 30 días. Te devolvemos los $49.999 completos, sin hacer preguntas." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-144" />

          <FAQItem question="¿Cuánto tiempo necesito?" answer="2 horas al día son suficientes. La mayoría de las personas lo hacen en las noches y fines de semana." isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-145" />

          <FAQItem question="¿Funciona desde cualquier país?" answer="Sí. Solo necesitas internet. Todo se maneja en línea." isOpen={openIndex === 6} onToggle={() => handleToggle(6)} data-id="element-146" />
        </div>

        <CTAButton text="DESCARGAR LA GUÍA LPM™ POR $49.999 AHORA" subtitle="Descarga Inmediata · Garantía de 30 Días · Pago Único" scrollTo="ebook-main" data-id="element-147" />
      </div>
    </section>;
}